export const PublicBucket = "public";
export const PrivateBucket = "online";
export const TemporaryBucket = "tmp";
export const PublicUrlPrefix = "https://public.youka.io";

export const CreditPerCreateKaraokeWithAlignment = 5;
export const CreditPerCreateKaraokeWithTranscription = 10;
export const CreditPerExportVideo = 1;
export const CreditPerSyncLyricsAlignment = 1;
export const CreditPerSyncLyricsTranscription = 5;
export const CreditPerStemSeparation = 1;
export const TrialCredits = 50;
export const TrialCreditsExpirationDays = 30;

export const DefaultPaginationLimit = 20;
export const MaxPaginationLimit = 100;

export const CAUSE_INSUFFICIENT_CREDITS = "INSUFFICIENT_CREDITS";
export const DefaultCreditHoldExpirationMinutes = 15;

export const DefaultBackgroundImageUrl =
  "https://public.youka.io/background.jpg";
